module.exports = __webpack_public_path__ + "static/iPad Pro - Apple-cba873ecef0356128ed34178af2e73a1.png";